module.exports = __webpack_public_path__ + "static/media/hero.fe8f0046.jpg";